import auth from "./list/authRequests";
import session from "./list/sessionsRequests";
import user from "./list/userRequests";
import wallet from "./list/walletRequests";
import factor from "./list/factorRequests";
import packages from "./list/packageRequest";
import cart from "./list/cart";
import messenger from "./list/messengerRequests";
import exercise from "./list/exerciseRequests";
import match_making from "./list/match_making";
import matchmaking_v2 from "./list/matchmaking_v2";
import matchmaking_v2_sandbox from "./list/matchmaking_v2_sandbox";
import test from "./list/testRequests";
import payment from "./list/PaymentRequests";
import offlinePayment from "./list/offlinepaymentRequest";
import preSessionRequests from "./list/preSessionRequests";
import setSession from "./list/setSessionRequests";
import care from "./list/careRequests";
import treatment_assessment from "./list/treatmentAssessmentRequests";

export default {
    auth,
    session,
    user,
    wallet,
    factor,
    packages,
    cart,
    messenger,
    exercise,
    match_making,
    matchmaking_v2,
    matchmaking_v2_sandbox,
    test,
    payment,
    offlinePayment,
    preSessionRequests,
    setSession,
    care,
    treatment_assessment,
};
